import React from 'react';
import '../less/deposits.less';
import usage_block_data from '../enums/usage_block_data.json';
import usage_block_data_2 from '../enums/usage_block_overnight_data.json';
import usage_block_data_3 from '../enums/usage_block_remain_precent_data.json';
import UsageBlock from '../../../../../auxiliary-components/shared/UsageBlock';
import BusinessOrder from '../../../../BusinessOrder';
import overnight_img from '../img/overnight-block_img.png';
import TabsNew from '../../../../../auxiliary-components/shared/TabsNew';
import FilesForDownload from '../../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import TransferTableAdmin from "../../../../../auxiliary-components/shared/TransfersTableAdmin";
import DOMPurify from 'utils/sanitize';
import serviceUsageItems from '../enums/service_usage_items.json';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import { Preloader } from 'MWComponents';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import SliderComponent from './../../../../../auxiliary-components/shared/Slider';

const DEPOSITS_MODAL_SLIDE_ID = 185;

export default function template() {
    const isMobile = this.isViewportMobile(),
      modal = this.state.showModal ? <BusinessOrder attribute="deposit" closeModal={this.toggleModal} /> : '',
      calcModal = this.state.showCalcModal ? <BusinessOrder attribute="deposits_business" closeModal={this.toggleCalcModal} /> : '',
      modes = this.state.modes,
      model = this.getModel();

      const tariffsData = model && model.realRates && model.realRates.length
        ? [
            {
              label: `${model.realRates[0]}${this.l10n('PERCENT')}`,
              value: `${this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_CARDS_TARIFFS_CELL_1_VALUE_1')} ${model.getMinSumEdge().toLocaleString('uk-UA')} ${this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_CARDS_TARIFFS_CELL_1_VALUE_2')}`
            },
            {
              label: `${model.realRates[1]}${this.l10n('PERCENT')}`,
              value: this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_CARDS_TARIFFS_CELL_2_VALUE')
            },
            {
              label: `${model.realRates[2]}${this.l10n('PERCENT')}`,
              value: this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_CARDS_TARIFFS_CELL_3_VALUE')
            },
            {
              label: `${model.realRates[3]}${this.l10n('PERCENT')}`,
              value: this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_CARDS_TARIFFS_CELL_4_VALUE')
            }
          ]
        : [];

    return (
        <div className='module-services'>
            <div className='business-deposits-module'>
                <div className='slider-container'>
                    {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')} modalSlideId={DEPOSITS_MODAL_SLIDE_ID} toggleModal={this.toggleModal}></SliderComponent>}
                </div>
                <div className='content'>
                    <UsageBlock
                        isMobile={isMobile}
                        page={'business-deposits'}
                        data={usage_block_data}
                        className='col-3-row-1'
                    ></UsageBlock>
                    <div className='overnight-block'>
                        <div className='overnight-block-left-side'>
                            <h2 className='overnight-block-left-side-title' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('BUSINESS_DEPOSITS_OVERNIGHT_TITLE'))}}></h2>
                            <div className='overnight-block-left-side-subtitle' dangerouslySetInnerHTML={{ __html: isMobile ? DOMPurify.sanitize(this.l10n('BUSINESS_DEPOSITS_OVERNIGHT_SUBTITLE_MOB')) : DOMPurify.sanitize(this.l10n('BUSINESS_DEPOSITS_OVERNIGHT_SUBTITLE'))}}></div>
                            <button className='overnight-block-left-side-button' onClick={this.scrollToOvernightDetails}>
                                {this.l10n('FIND_OUT_MORE')}
                              </button>
                        </div>
                        <div className='overnight-block-right-side'>
                            <img className='overnight-block-right-side-img' src={overnight_img} alt="overnight_img" />
                        </div>
                    </div>
                    <h2 className='rates-title' id='anchor_deposits_msb' dangerouslySetInnerHTML={{ __html: isMobile ? DOMPurify.sanitize(this.l10n('BUSINESS_DEPOSIT_CORP_DEPS_MOB')) : DOMPurify.sanitize(this.l10n('BUSINESS_DEPOSIT_CORP_DEPS'))}}></h2>
                    <TabsNew modes={modes} mode={this.state.mode} page={'quick-cash'} isMobile={isMobile} toggle={this.toggleMode} instructionMode={false} activeTabVisible>
                      <div className="wrapper" type={modes[0].mode}>
                        <div className='intelExpress-table-divider'></div>
                        <TransferTableAdmin data={this.widgetsHelper.getWidget.call(this, 'information_table')} page="business-deposits" isMobile={isMobile} customWidth additionToDropdownTitle={this.l10n('JUST_DAYS')}/>
                      </div>
                      <div className="wrapper" type={modes[1].mode}>
                        <div className='intelExpress-table-divider'></div>
                        <TransferTableAdmin data={this.widgetsHelper.getWidget_2.call(this, 'information_table')} page="business-deposits" isMobile={isMobile} customWidth additionToDropdownTitle={this.l10n('JUST_DAYS')}/>
                      </div>
                      <div className="wrapper overnight-terms" type={modes[2].mode} >
                        <UsageBlock
                          isMobile={isMobile}
                          page={'business-deposits-2'}
                          data={usage_block_data_2}
                          className='col-2-row-2'
                        ></UsageBlock>
                      </div>
                      <div className="wrapper remain-percent-terms" type={modes[3].mode} >
                        <div className="remain-percent">
                          <div className="remain-percent__text">
                            <p>{this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_TEXT_01')}</p>
                            <p>{this.l10n('BUSINESS_DEPOSITS_REMAIN_PERCENT_TEXT_02')}</p>
                          </div>
                          {tariffsData.length > 0 ? (
                            <Tariffs items={tariffsData} />
                          ) : <Preloader />}
                          <UsageBlock
                            isMobile={isMobile}
                            page={'business-deposits-3'}
                            data={usage_block_data_3}
                            className='col-3-row-1'
                            noTitle
                          ></UsageBlock>
                          <div className="remain-percent__hint">{this.l10n("BUSINESS_DEPOSITS_REMAIN_PERCENT_TEXT_03")}</div>
                          <div className="service-usage">
                            <h2 className="service-usage__title">{this.l10n('BUSINESS_DEPOSITS_SERVICE_USAGE_TITLE')}</h2>
                            <div className="service-usage__body">
                              {serviceUsageItems.map((item, index) => (
                                <div key={index} className="service-usage__item item-service-usage">
                                  <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                                  <div className="item-service-usage__text">{this.l10n(item.text)}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                          {model.realRates ? (
                            <CalculatorNew model={model} type={"business_deposits"} {...this.props} toggleModal={() => this.toggleCalcModal()} tab={this.state.mode}/>
                          ) : <Preloader />}
                        </div>
                      </div>
                    </TabsNew>
                  <FilesForDownload style={{marginBottom: 0}} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>
                    </div>
            </div>
            {modal}
            {calcModal}
        </div>
    );
}
